import React, { memo, useCallback, useEffect, useMemo, useState } from "react";
import { LuPencil } from "react-icons/lu";
import { BiPlus } from "react-icons/bi";
import Map from "./Map/Map";
import commonUtility from "../../../utils/domain/commonUtility";
import { Col } from "reactstrap";
import { checkFieldError } from "./CustomerFormUtil";

const translator = require("../../../utils/translator/translator");

const DeliveryAddressBox = ({
     selectedAddressKey,
     setSelectedAddressKey,
     address,
     address2,
     address3,
     address4,
     onChange = (key, value) => {},
     showError,
}) => {
     const [showChooseAddressModal, setshowChooseAddressModal] = useState({
          visible: false,
          addressKey: null,
          addressValue: null,
     });
     const [error, setError] = useState(null);

     const addresses = useMemo(() => {
          const res = [];

          address && res.push({ label: address, value: "address" });
          address2 && res.push({ label: address2, value: "address2" });
          address3 && res.push({ label: address3, value: "address3" });
          address4 && res.push({ label: address4, value: "address4" });

          return res;
     }, [address, address2, address3, address4]);

     const handleOnItemClick = (item) => {
          setSelectedAddressKey(item.value);
          onChange(item.key, item.value);
     };
     const handleAddAddress = () => {
          const totalAddresses = [
               ["address", address],
               ["address2", address2],
               ["address3", address3],
               ["address4", address4],
          ];

          for (const [addressKey, addressValue] of totalAddresses) {
               if (addressValue === "" || addressValue === undefined || addressValue === null) {
                    setshowChooseAddressModal({
                         visible: true,
                         addressKey,
                         addressValue: null,
                    });
                    break;
               }
          }
     };

     const handleCloseChooseAddressModal = useCallback(() => {
          setshowChooseAddressModal((prev) => ({
               ...prev,
               visible: false,
          }));
     }, []);

     const handleSaveChooseAddressModal = useCallback(
          (selectedAddress, selectedLatLng) => {
               onChange(showChooseAddressModal.addressKey, selectedAddress);
               setSelectedAddressKey(showChooseAddressModal.addressKey);
          },
          [onChange, showChooseAddressModal.addressKey, setSelectedAddressKey]
     );

     const handleOnItemEdit = useCallback((item) => {
          setshowChooseAddressModal((prev) => ({
               ...prev,
               visible: true,
               addressKey: item.value,
               addressValue: item.label,
          }));
     }, []);

     const propertyAddress = useMemo(() => commonUtility.getProperty().address, []);

     useEffect(() => {
          if (showError)
               setError(
                    checkFieldError("address", selectedAddressKey, {
                         address,
                         address2,
                         address3,
                         address4,
                    })
               );
     }, [showError, selectedAddressKey, address, address2, address3, address4]);

     return (
          <Col>
               {showChooseAddressModal.visible && (
                    <Map
                         selectedAddress={showChooseAddressModal.addressValue}
                         propertyAddress={propertyAddress}
                         onSave={handleSaveChooseAddressModal}
                         onClose={handleCloseChooseAddressModal}
                    />
               )}

               <div
                    className="rounded px-3 py-2"
                    style={{
                         borderWidth: "var(--bs-border-width)",
                         borderStyle: "var(--bs-border-style)",
                         borderColor: showError && error ? "var(--bs-form-invalid-border-color)" : "var(--bs-border-color)",
                    }}
               >
                    <p className="text-sm" style={{ marginBottom: "4px" }}>
                         {translator.getLabel("select_delivery_address")} <span className="text-danger">*</span>
                    </p>
                    <div className="d-flex flex-column" style={{ overflowY: "auto", maxHeight: "calc(18.5vh - 1.75rem)" }}>
                         {addresses.map((item) => (
                              <DeliveryAddressItem
                                   key={item.value}
                                   item={item}
                                   active={selectedAddressKey === item.value}
                                   onClick={handleOnItemClick}
                                   onEdit={handleOnItemEdit}
                              />
                         ))}
                         {addresses.length < 4 && (
                              <div className="d-flex align-items-center gap-1 p-2" onClick={handleAddAddress}>
                                   <BiPlus style={{ width: "1.2rem", height: "1.2rem" }} />
                                   {translator.getLabel("add_new_address")}
                              </div>
                         )}
                    </div>
               </div>
               {showError && error && <div className="invalid-feedback d-block">{error}</div>}
          </Col>
     );
};

export default memo(DeliveryAddressBox);

const DeliveryAddressItem = memo(({ item, active, onClick = () => {}, onEdit = () => {} }) => {
     const handleOnClick = () => onClick(item);
     const handleOnEdit = () => onEdit(item);
     return (
          <div
               className="d-flex px-2  rounded py-2 align-items-center justify-content-between"
               style={{ background: active ? "var(--colors-primary20)" : "unset"}}
               onClick={handleOnClick}
          >
               <div className="d-flex px-2 rounded align-items-center gap-2" style={{ flex: 1 }}>
                    <div className="d-flex justify-content-center align-items-center bg-primary rounded-5" style={{ width: "21px", height: "21px", aspectRatio: 1 }}>
                         {active ? (
                              <div style={{ width: "13px", height: "13px", aspectRatio: 1 }} className="bg-primary rounded-5"></div>
                         ) : (
                              <div style={{ width: "13px", height: "13px", aspectRatio: 1 }} className="bg-white rounded-5"></div>
                         )}
                    </div>
                    <div className="text-md">{item.label}</div>
               </div>
               <LuPencil className="w-auto h-auto px-3 py-2 border-start" onClick={handleOnEdit} />
          </div>
     );
});
